import FolderOverview from 'scoreboard/components/folder-overview'
import permissions from 'scoreboard/components/permissions'

var BookmarksFolderOverview = FolderOverview.extend({

	allowEdit: function() {
		return permissions.bookmarks()
	}

})

export default BookmarksFolderOverview
BookmarksFolderOverview.__filename__ = 'bookmarks/bookmarks-folder-overview.js'
